<template>
  <div class="mx-3 alert-success">
    <SuccessItem v-for="(item, i) in storeSuccess" :key="i" :item="item" :index="i" />
  </div>
</template>

<script>
import SuccessItem from '@/components/Success/SuccessItem';
import { mapState } from 'pinia';
import { useSuccessStore } from '@/store/stores';
export default {
  name: 'Success',
  components: { SuccessItem },
  computed: {
    ...mapState(useSuccessStore, ['storeSuccess']),
  },
};
</script>

<style scoped></style>
